import fetch from 'isomorphic-fetch';
import {API2_URL, STRATEGIES_REQUEST,STRATEGIES_SHOW, STRATEGIES_EDIT, STRATEGIES_CLEAR, STRATEGIES_FAIL} from "../store/config";
import {newNotification} from "./notifications";
import {history} from "../store/store";
import {sessionService} from 'redux-react-session';
import _ from 'lodash';

export const strategiesShow = (page=1, filters={}) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			let params = '';
			_.mapKeys(filters, (value, key) => {
				if(value){
					params = `${params}&${key}=${value}`;
				}
			});

			dispatch(strategiesRequest());
			return fetch(`${API2_URL}/proigualdad/strategies?page=${page}${params}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(strategiesData(json)),
					error => {
						dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(strategiesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const strategiesList = () => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			dispatch(strategiesRequest());
			return fetch(`${API2_URL}/proigualdad/strategies?per_page=all`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(strategiesData(json)),
					error => {
						dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(strategiesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const strategieEdit = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			dispatch(strategiesRequest());
			dispatch(strategiesClear());
			return fetch(`${API2_URL}/proigualdad/strategies/${id}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(strategiesEditData(json)),
					error => {
						dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(strategiesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const strategieEditSave = (values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(values)
			};

			dispatch(strategiesRequest());
			return fetch(`${API2_URL}/proigualdad/strategies${values.id ? `/${values.id}?_method=PUT`:''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"La estrategia se ha guardado correctamente", type: "success"}));
						if(_.isEmpty(values.id)){
							history.push(`/proigualdad/estrategias/editar/${json.data.id}`);
						}
						return dispatch(strategiesEditData(json))
					},
					error => {
						dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(strategiesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const strategieDelete = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'delete'
			};

			dispatch(strategiesRequest());
			return fetch(`${API2_URL}/proigualdad/strategies/${id}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"La estrategia se ha borrado correctamente", type: "success"}));
						dispatch(strategiesShow())
					},
					error => {
						dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(strategiesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const strategiesData = (json) => {
	return {
		type: STRATEGIES_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const strategiesEditData = (json) => {
	return {
		type: STRATEGIES_EDIT,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const strategiesRequest = () => {
	return {
		type: STRATEGIES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const strategiesClear = () => {
	return {
		type: STRATEGIES_CLEAR,
		payload: {},
		timestamp: Date.now()
	}
}

const strategiesFail = (error) => {
	return {
		type: STRATEGIES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/strategies.js